import { useEffect } from 'react';
import SelectOrder from '../../components/select/SelectOrder';

const StepOrder = ({
  totalAmount,
  apiUrl,
  removeDrafts,
  apiFilter = '(status = 0 OR status = 3) AND isDraft = false',
  dataCollection,
  updateDataCollection,
  activeStep,
  setActiveStep,
  step,
  updateValidation,
  button,
  includeProject,
  onClose = () => {},
}) => {
  function handleOrderSelect(order) {
    const insertData = {
      order: order,
      recipient: order.recipient,
      recipientType: order.recipientType,
      title: order.title,
    };
    if (includeProject && order.project) {
      insertData.project = order.project;
    }
    updateDataCollection(insertData);

    //next step
    setActiveStep(activeStep + 1);
  }

  useEffect(() => {
    if (dataCollection && dataCollection.order) updateValidation(true);
  }, []);

  return (
    <SelectOrder
      totalAmount={totalAmount}
      apiUrl={apiUrl}
      onSelect={handleOrderSelect}
      filter={apiFilter}
      selected={dataCollection && dataCollection.order}
      button={button}
      removeDrafts={removeDrafts}
      useSearch
    />
  );
};

export default StepOrder;
